import moment from 'moment';
import _ from 'lodash';
import Vue from 'vue'

const state = {
  trx_activity:{
    expired_at: null,
    products: [],
    page_module: '',
    customer_detail:{
      first_name: '',
      last_name: '',
      email: '',
      phone_number: '',
    },
    promo_code: '',
    master_avb: []
  },
  trx_outlet:{
    created_at: '',
    page_module: '',
    products: [],
    customer_detail:{
      first_name: '',
      last_name: '',
      email: '',
      phone_number: '',
    },
    notes: '',
    promo_code: '',
    table_number: '',
    lock_table_number: false,
    delivery:{
      use: false,
      address:{
        latitude: null,
        longitude: null,
        full: '',
        landmark: ''
      },
      inquiry: {}
    }
  },
  concierge_trx_general:{
   contactDetails: {
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
   },
   notes: ""
  }
}

const getters = {
  getConciergeTrxGeneral: (state) => state.concierge_trx_general,
  getActivityTrxPageModule: state => state.trx_activity.page_module,
  getActivityTrxProducts: state => state.trx_activity.products,
  getActivityTrx: state => state.trx_activity,
  getActivityTrxMasterAvb: state => state.trx_activity.master_avb,
  getActivityTrxExpiredAt: state => state.trx_activity.expired_at,
  getActivityTrxCustomerDetail: state => state.trx_activity.customer_detail,
  getActivityTrxSubTotal: (state) => {
    let total = 0

    state.trx_activity.products.forEach(product => {
      total += product.base_price.base
    });
    
    return total
  },
  getActivityTrxTaxService: (state) => {
    let total = 0

    state.trx_activity.products.forEach(product => {
      total += (product.base_price.taxes+product.base_price.services)
    });
    
    return total
  },
  getActivityTrxPromotion: (state) => {
    let total = 0

    state.trx_activity.products.forEach(product => {
      total += product.base_price.promotion_amount
    });
    
    return total
  },
  getActivityTrxTotal: (state) => {
    let total = 0
    state.trx_activity.products.forEach(product => {
      total += product.base_price.final
    });
    return total
  },
  getActivityTrxDisplayTotal: (state) => {
    let total = 0
    state.trx_activity.products.forEach(product => {
      total += product.base_price.display.final
    });
    return total
  },
  getActivityTrxPromoCode: (state) => state.trx_activity.promo_code,

  getOutletTrxPageModule: state => state.trx_outlet.page_module,
  getOutletTrxProducts: state => state.trx_outlet.products,
  getOutletTrxNotes: state => state.trx_outlet.notes,
  getOutletTrxPromoCode: state => state.trx_outlet.promo_code,
  getOutletTrxCustomerDetail: state => state.trx_outlet.customer_detail,
  getOutketTrxLockTableNumber: state => state.trx_outlet.lock_table_number,
  getOutletTrxTableNumber: state => state.trx_outlet.table_number,
  getOutletTrxSubTotal: (state) => {
    let total = 0
    state.trx_outlet.products.forEach(product => {
      let is_variant = product.variants.length > 0 ? true : false
      if(!is_variant){
        total += (product.qty*product.product_data.price.price_sell)
      }else{
        product.variants.forEach(variant=>{
          total += (variant.qty*variant.variant_data.price.price_sell)
        })
      }
    });
    return total
  },
  getOutletTrxTotalItem: (state) => {
    let total = 0
    state.trx_outlet.products.forEach(product => {
      let is_variant = product.variants.length > 0 ? true : false
      if(!is_variant){
        total += product.qty
      }else{
        product.variants.forEach(variant=>{
          total += variant.qty
        })
      }
    });
    return total
  },
  getOutletTrxPromotion: (state) => {
    let total = 0

    state.trx_outlet.products.forEach(product => {
      let is_variant = product.variants.length > 0        
      if(is_variant){
        product.variants.forEach(variant=>{
          let sub_total = variant.variant_data.price.promotion_amount*variant.qty
          total += sub_total
        })
      }else{
        let sub_total = product.product_data.price.promotion_amount*product.qty
        total += sub_total
      }
    });
    
    return total
  },
  getOutletTrxTaxService: (state) => {
    let total = 0

    state.trx_outlet.products.forEach(product => {
      let is_variant = product.variants.length > 0        
      if(is_variant){
        product.variants.forEach(variant=>{
          let price = variant.variant_data.price
          let sub_total = (price.tax_amount+price.service_amount)*variant.qty
          total += sub_total
        })
      }else{
        let price = product.product_data.price
        let sub_total = (price.tax_amount+price.service_amount)*product.qty
        total += sub_total
      }
    });
    
    return total
  },
  getOutletTrxTotal: (state) => {
    let total = 0
    state.trx_outlet.products.forEach(product => {
      let is_variant = product.variants.length > 0 ? true : false
      if(!is_variant){
        total += (product.qty*Number(product.product_data.price.price_sell_final_with_tax_service))
      }else{
        product.variants.forEach(variant=>{
          total += (variant.qty*Number(variant.variant_data.price.price_sell_final_with_tax_service))
        })
      }
    });
    return total
  },
  getOutletTrxDelivery: (state) => {
    return state.trx_outlet.delivery
  }
}

const mutations = {  
  // GENERAL
  setConciergeTrxGeneralContact(state, payload){
    try {
      if(_.isEmpty(payload)) throw new Error("Data is empty");

      payload.forEach((field) => {
        const { key, value } = field;
        if(key in state.concierge_trx_general.contactDetails){
          state.concierge_trx_general.contactDetails[key] = value
        }
        
      })
           
    } catch (error) {
      console.log("ERROR VUEX setConciergeTrxGeneralContact() : ", error.message)
    }
  },
  setConciergeTrxGeneralNotes(state,payload){
    state.concierge_trx_general.notes = payload
  },
  
  // ACTIVITY
  setTrxActivityProduct(state, payload) {
    const { products, master_avb } = state.trx_activity;
  
    if (products.length === 0) {
      state.trx_activity.expired_at = moment().add(30, 'minutes');
      state.trx_activity.page_module = payload.page_module
    }
  
    const productIndex = products.findIndex(x => x.original_data.id === payload.product.id);
  
    const newData = {
      original_data: payload.product,
      service_date: payload.date,
      service_time: payload.time,
      therapist_gender: payload.gender,
      place_choice: payload.place,
      qty: payload.qty,
      base_price: payload.base_price
    };
    const service_date = moment(payload.date).format("YYYY-MM-DD");
  
    const findOrCreate = (array, condition, createFn) => {
      let entry = array.find(condition);
      if (!entry) {
        entry = createFn();
        array.push(entry);
      }
      return entry;
    };

    const updateMasterAvbForMasterProduct = (ref_id,availability) => {
      let product_in_master_avb = master_avb.findIndex(x=>x.reference_id == ref_id)
      if(product_in_master_avb != -1){
        let product_date_in_master_avb = master_avb[product_in_master_avb].dates.findIndex(x=>x.date == service_date)
        if(product_date_in_master_avb != -1){
          master_avb[product_in_master_avb].dates[product_date_in_master_avb].availability -= payload.qty
        }else{
          master_avb[product_in_master_avb].dates.push({
            date: service_date,
            original_avb: availability,
            availability: availability - payload.qty
          })
        }
      }
    }

    // ADD NEW PRODUCT
    if (productIndex === -1) {

      const updateMasterAvbForChildProduct = (master_list) => {
        master_list.forEach(msb=>{
          const masterEntry = findOrCreate(
            master_avb,
            entry => entry.reference_id === msb.reference_id,
            () => ({
              reference_id: msb.reference_id,
              dates: [],
            })
          );

          if(masterEntry.dates.length == 0){
            let master_avb_in_cart = products.find(x=>{
              let is_schedule_matched = x.original_data.use_schedule && x.service_time.id == masterEntry.reference_id
              let is_standart_matched = !x.original_data.use_schedule && x.original_data.ga_concierge_id == masterEntry.reference_id
              let is_service_date_matched = moment(x.service_date).format("YYYY-MM-DD") == service_date
              
              if((is_schedule_matched || is_standart_matched) && is_service_date_matched){
                return x
              }else{
                return false
              }
            })

            let param_new_date = {
              date: service_date,
              original_avb: msb.availability,
              availability: msb.availability
            }
            if(master_avb_in_cart){
              param_new_date.availability -= master_avb_in_cart.qty
            }
            const { qty: masterAvbQty } = msb;
            param_new_date.availability -= masterAvbQty * newData.qty;

            masterEntry.dates.push(param_new_date)
          }else{
            const dateEntry = findOrCreate(masterEntry.dates, entry => entry.date === service_date, () => ({ date: service_date, original_avb: msb.availability, availability: msb.availability }));
      
            const { qty: masterAvbQty } = msb;
            dateEntry.availability -= masterAvbQty * newData.qty;
          }
          
        })
      }
      
      // SCHEDULE
      if(payload.product.use_schedule){
        // CHILD
        if(payload.time.use_master_availability){
          updateMasterAvbForChildProduct(payload.time.master_availability_reference_data)
        }else{ // MASTER
          updateMasterAvbForMasterProduct(newData.service_time.id,newData.service_time.availability)
        }
      }else{ // STANDART
        // CHILD
        if(payload.product.use_master_availability){
          updateMasterAvbForChildProduct(payload.product.master_availability_reference_data)
        }else{ // MASTER
          updateMasterAvbForMasterProduct(payload.product.ga_concierge_id,payload.product.availability)
        }
      }
      products.push(newData);
    } 
    // UPDATE PRODUCT
    else { 
      const product_state = products[productIndex]

      const restoreMasterAvb = (reference_id,qty) =>{
        const savedMsb = master_avb.find(x=>x.reference_id == reference_id)
        if(savedMsb){
          let previous_service_date = moment(product_state.service_date).format("YYYY-MM-DD")
          const msbDate = savedMsb.dates.find(x=>x.date == previous_service_date)
          if(msbDate){
            msbDate.availability += qty
            if(msbDate.availability >= msbDate.original_avb){
              const msbDateIndex = savedMsb.dates.findIndex(x=>x.date == msbDate.date)
              savedMsb.dates.splice(msbDateIndex,1)

              if(savedMsb.dates.length == 0){
                const msbIndex = savedMsb.dates.findIndex(x=>x.date == msbDate.date)
                master_avb.splice(msbIndex,1)
              }
            }
          }
        }
      }

      const updateMasterAvb = (msb) => {
        const masterEntry = findOrCreate(
          master_avb,
          entry => entry.reference_id === msb.reference_id,
          () => ({
            reference_id: msb.reference_id,
            dates: [],
          })
        );
        const dateEntry = findOrCreate(masterEntry.dates, entry => entry.date === service_date, () => ({ date: service_date, original_avb: msb.availability, availability: msb.availability }));
        const { qty: masterAvbQty } = msb;
        dateEntry.availability -= masterAvbQty * newData.qty;
      }
      
      // SCHEDULE
      if(payload.product.use_schedule){
        // CHILD
        if(payload.time.use_master_availability){
          // RESTORE MASTER AVAILABILITY
          product_state.service_time.master_availability_reference_data.forEach(msb=>restoreMasterAvb(msb.reference_id, msb.qty*product_state.qty))
    
          // ADD/UPDATE MASTER AVAILABILITY
          payload.time.master_availability_reference_data.forEach(msb=>{
            updateMasterAvb(msb)
          })
        }else{ // MASTER
          restoreMasterAvb(product_state.service_time.id, product_state.qty)
          updateMasterAvbForMasterProduct(payload.time.id,payload.time.availability)
        }
      }else{ // STANDART
        // CHILD
        if(payload.product.use_master_availability){
          // RESTORE MASTER AVAILABILITY
          product_state.original_data.master_availability_reference_data.forEach(msb=>restoreMasterAvb(msb.reference_id, msb.qty*product_state.qty))
          
          // ADD/UPDATE MASTER AVAILABILITY
          payload.product.master_availability_reference_data.forEach(msb=>{
            updateMasterAvb(msb)
          })
        }else{ // MASTER
          restoreMasterAvb(product_state.original_data.ga_concierge_id, product_state.qty)
          updateMasterAvbForMasterProduct(payload.product.ga_concierge_id,payload.product.availability)
        }
      }
      
      Vue.set(products, productIndex, newData);
    }
  },  
  updateTrxActivityProductPricing(state,payload){
    let product_in_cart = state.trx_activity.products.findIndex(x=>x.original_data.id == payload.product.id)
    if(product_in_cart != -1){
      let new_data = {
        original_data: payload.product,
        service_date:  payload.date,
        service_time: payload.time,
        therapist_gender: payload.gender,
        place_choice: payload.place,
        qty: payload.qty,
        base_price: payload.base_price
      }
      Vue.set(state.trx_activity.products,product_in_cart,new_data)
    }else{
      console.log("PRODUCT NOT FOUND")
    }
  },
  restoreTrxActivityProduct(state){
    for (let i = 0; i < state.trx_activity.products.length; i++) {
      let copied_data = state.trx_activity.products[i].backup_original
      let restore_data = copied_data
      restore_data.backup_original = {...copied_data}
      Vue.set(state.trx_activity.products,i,restore_data)
    }
  },
  removeTrxActivityProduct(state,payload){
    const { products, master_avb } = state.trx_activity;

    let product_in_state = products.findIndex(x=>x.original_data.id == payload.product.id)
    if(product_in_state != -1){
      let product_state = Vue.prototype.$deepCopy(products[product_in_state])
      let service_date = moment(product_state.service_date).format("YYYY-MM-DD")
      
      if(products.length == 0){
        state.trx_activity.expired_at = null
        state.trx_activity.page_module = ''
        state.trx_activity.master_avb = []
      }else{
        const restoreMasterAvb = (reference_id,qty) => {
          let product_in_master_avb = master_avb.findIndex(x=>x.reference_id == reference_id)
          if(product_in_master_avb != -1){
            let date_in_master_avb = master_avb[product_in_master_avb].dates.findIndex(x=>x.date == service_date)
            if(date_in_master_avb != -1){
              const {original_avb} = master_avb[product_in_master_avb].dates[date_in_master_avb]
              master_avb[product_in_master_avb].dates[date_in_master_avb].availability += qty                
              if(master_avb[product_in_master_avb].dates[date_in_master_avb].availability >= original_avb){
                master_avb[product_in_master_avb].dates.splice(date_in_master_avb,1)
                if(master_avb[product_in_master_avb].dates.length == 0){
                  master_avb.splice(product_in_master_avb,1)
                }
              }
            }
          } 
        }
        
        // SCHEDULE
        if(product_state.original_data.use_schedule){
          if(product_state.service_time.use_master_availability){
            product_state.service_time.master_availability_reference_data.forEach(ref=>{
              restoreMasterAvb(ref.reference_id,product_state.qty*ref.qty)
            })
          }else{
            restoreMasterAvb(product_state.service_time.id,product_state.qty)
          }
        } else{ // STANDART
          if(product_state.original_data.use_master_availability){
            product_state.original_data.master_availability_reference_data.forEach(ref=>{
              restoreMasterAvb(ref.reference_id,product_state.qty*ref.qty)
            })
          }else{
            restoreMasterAvb(product_state.original_data.ga_concierge_id,product_state.qty)
          }
        }
      }

      state.trx_activity.products.splice(product_in_state,1)
    }else{
      console.log(`Product ${payload.product.name} is not stored in vuex`)
    }
  },
  clearTrxActivityProduct(state){
    state.trx_activity = {
      expired_at: '',
      page_module: '',
      products: [],
      customer_detail:{
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
      },
      promo_code: '',
      master_avb: []
    }
  },
  setActivityTrxCustomerDetail(state,payload){
    for (let param of payload){
      Vue.set(state.trx_activity.customer_detail,param.key,param.value)
    }
  },
  setActivityTrxPromoCode(state,payload){
    state.trx_activity.promo_code = payload
  },

  // OUTLET
  clearTrxOutletProduct(state){
    state.trx_outlet = {
      created_at: '',
      page_module: '',
      products: [],
      customer_detail:{
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
      },
      promo_code: '',
      table_number: '',
      lock_table_number: false,
      notes:'',
      delivery:{
        use: false,
        address:{
          latitude: null,
          longitude: null,
          full: '',
          landmark: ''
        },
        inquiry: {}
      }
    }
  },
  setTrxOutletProduct(state, payload){    
    if(state.trx_outlet.products.length == 0){
      state.trx_outlet.created_at = moment();
      state.trx_outlet.page_module = payload.page_module
    }
    let product_in_state = state.trx_outlet.products.findIndex(x=>x.product_data.id == payload.product.id)
    let is_ref_product = payload.ref == 'product'
    let qty_and_notes = (fill_data=true) =>{
      let return_data = {qty: 0, notes: ''}
      if(fill_data) return_data = {qty: payload.qty, notes: payload.notes}
      return return_data
    }

    // NEW DATA
    if(product_in_state == -1){
      let new_data = {
        product_data: payload.product,
        temp_product_data: payload.product,
        ...qty_and_notes(is_ref_product),
        variants: is_ref_product ? [] : [{variant_data: payload.variant, temp_variant_data: payload.variant,...qty_and_notes()}],
      }
      state.trx_outlet.products.push(new_data)
    }
    // UPDATE DATA
    else{
      let product_selected = state.trx_outlet.products[product_in_state]

      let updateQtyAndNotes = (ref = 'product',variant_index) => {
        if(ref == 'product'){
          state.trx_outlet.products[product_in_state].qty = payload.qty
          state.trx_outlet.products[product_in_state].notes = payload.notes
        }else{
          state.trx_outlet.products[product_in_state].variants[variant_index].qty = payload.qty
          state.trx_outlet.products[product_in_state].variants[variant_index].notes = payload.notes
        }
      }
      
      if(is_ref_product) {
        updateQtyAndNotes()
      }else{
        let variant_in_state = product_selected.variants.findIndex(x=>x.variant_data.id == payload.variant.id)
        if(variant_in_state != -1){
          updateQtyAndNotes('variant',variant_in_state)
        }else{
          state.trx_outlet.products[product_in_state].variants.push({variant_data: payload.variant,temp_variant_data: payload.variant, ...qty_and_notes()})
        }
      }
      if(state.trx_outlet.products.length == 0){
        state.trx_outlet.created_at = null;
        state.trx_outlet.page_module = ''
      }
    }
  },
  updateTrxOutletProductPricing(state, payload){
    let product_in_state = state.trx_outlet.products.findIndex(x=>x.product_data.id == payload.product.id)
    if(product_in_state != -1){
      let cart = state.trx_outlet.products[product_in_state]
      let is_variant = cart.variants.length > 0
      if(is_variant){
        let variant_in_state = cart.variants.findIndex(x=>x.variant_data.id == payload.variant.id)
        if(variant_in_state != -1){
          Vue.set(state.trx_outlet.products[product_in_state].variants[variant_in_state],'variant_data',payload.variant)
        }else{
          console.log(`ERROR : VARIANT ${payload.name} NOT IN CART`)
        }
      }else{
        Vue.set(state.trx_outlet.products[product_in_state],'product_data',payload.product)
      }
    }else{
      console.log(`ERROR : PRODUCT ${payload.product.name} NOT IN CART`)
    }
  },
  restoreTrxOutletProduct(state){
    for (let i = 0; i < state.trx_outlet.products.length; i++) {
      let cart = state.trx_outlet.products[i]
      let is_variant = cart.variants.length > 0
      if(is_variant){
        cart.variants.forEach((variant,variant_i)=>{
          let copied_data = variant.temp_variant_data
          Vue.set(state.trx_outlet.products[i].variants[variant_i],'variant_data',copied_data)
        })
      }else{
        let copied_data = cart.temp_product_data
        Vue.set(state.trx_outlet.products[i],'product_data',copied_data)
      }
      
    }
  },
  restoreTrxOutletPricePerProduct(state,payload){
    let product_in_state = state.trx_outlet.products.findIndex(x=>x.product_data.id == payload.product.id)
    if(product_in_state != -1){
      let cart = state.trx_outlet.products[product_in_state]
      let is_variant = cart.variants.length > 0
      if(is_variant){
        let variant_in_state = cart.variants.findIndex(x=>x.variant_data.id == payload.variant.id)
        if(variant_in_state != -1){
          if(payload.action == 'restore'){
            let copied_data = cart.variants[variant_in_state].temp_variant_data
            Vue.set(state.trx_outlet.products[product_in_state].variants[variant_in_state],'variant_data',copied_data)
          }else{
            Vue.set(state.trx_outlet.products[product_in_state].variants[variant_in_state],'temp_variant_data',payload.variant)
            Vue.set(state.trx_outlet.products[product_in_state].variants[variant_in_state],'variant_data',payload.variant)
          }
        }else{
          console.log(`ERROR : VARIANT ${payload.name} NOT IN CART`)
        }
      }else{
        if(payload.action == 'restore'){
          let copied_data = cart.temp_product_data
          Vue.set(state.trx_outlet.products[product_in_state],'product_data',copied_data)
        }else{
          Vue.set(state.trx_outlet.products[product_in_state],'temp_product_data',payload.product)
          Vue.set(state.trx_outlet.products[product_in_state],'product_data',payload.product)
        }
      }
    }else{
      console.log(`ERROR : PRODUCT ${payload.product.name} NOT IN CART`)
    }
  },
  removeTrxOutletProduct(state,payload){
    let product_in_state = state.trx_outlet.products.findIndex(x=>x.product_data.id == payload.product.id)
    let is_ref_product = payload.ref == 'product'

    let clearIfEmpty = () =>{
      if(state.trx_outlet.products.length == 0){
        state.trx_outlet.created_at = null;
        state.trx_outlet.page_module = ''
      }
    }
    
    if(product_in_state != -1){
      if(is_ref_product){
        state.trx_outlet.products.splice(product_in_state,1)
        clearIfEmpty()
      }else{
        let product_selected = state.trx_outlet.products[product_in_state]
        let variant_in_state = product_selected.variants.findIndex(x=>x.variant_data.id == payload.variant.id)
        if(variant_in_state != -1){
          state.trx_outlet.products[product_in_state].variants.splice(variant_in_state,1)
          if(state.trx_outlet.products[product_in_state].variants.length == 0){
            state.trx_outlet.products.splice(product_in_state,1)
            clearIfEmpty()
          }
        }else{
          console.log(`ERROR : VARIANT ${payload.variant.name} NOT IN CART`)
        }
      }
    }else{
      console.log(`ERROR : PRODUCT ${payload.product.name} NOT IN CART`)
    }
  },
  setTrxOutletCustomerDetail(state,payload){
    for (let param of payload){
      Vue.set(state.trx_outlet.customer_detail,param.key,param.value)
    }
  },
  resetTrxOutletCustomerDetail(state){
    state.trx_outlet.customer_detail = {
      first_name: '',
      last_name: '',
      email: '',
      phone_number: '',
    }
  },
  setTrxOutletPromoCode(state,payload){
    state.trx_outlet.promo_code = payload
  },
  setTrxOutletTableNumber(state,payload){
    state.trx_outlet.table_number = payload
  },
  setTrxOutletLockTableNumber(state,payload){
    state.trx_outlet.lock_table_number = payload
  },
  setTrxOutletNotes(state,payload){
    state.trx_outlet.notes = payload
  },
  setTrxOutletDelivery(state,payload){
    state.trx_outlet.delivery = payload
  },
  resetTrxOutletDelivery(state,payload){
    state.trx_outlet.delivery.delivery = {
      use: false,
      address:{
        latitude: null,
        longitude: null,
        full: '',
        landmark: ''
      },
      inquiry: {}
    }
  },
  setTrxOutletDeliveryType(state,payload){
    state.trx_outlet.delivery.use = payload
  },
  setTrxOutletDeliveryInquiry(state,payload){
    state.trx_outlet.delivery.inquiry = payload
  },

  resetAllDataConcierge(state){
    state.trx_activity = {
      expired_at: '',
      products: [],
      customer_detail:{
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
      },
      promo_code: '',
      master_avb: []
    }
    state.trx_outlet = {
      created_at: '',
      page_module: '',
      products: [],
      customer_detail:{
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
      },
      promo_code: '',
      table_number: '',
      lock_table_number: false,
      notes: '',
      delivery:{
        use: false,
        address:{
          latitude: null,
          longitude: null,
          full: '',
          landmark: ''
        },
        inquiry: {}
      }
    }
    state.concierge_trx_general = {
      contactDetails: {
       first_name: '',
       last_name: '',
       email: '',
       phone_number: '',
      },
      notes: ""
     }
  }
}

export default{
  state,
  getters,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/concierge.js